/* eslint-disable @typescript-eslint/no-unused-vars */
import { DialogRoute, mergeQueryString } from 'bernie-core';
import { Layer } from 'bernie-view';
import { inject, observer } from 'mobx-react';
import React, {useEffect} from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom-v5-compat';
import { checkValue } from 'src/components/common/helper';
import { DayName, UitkDatePicker } from 'uitk-react-date-picker';

const setupTracker = (id, description) => {
  const callback = (_id, _description) => {
    return;
  };
  return {
    callback,
    description,
    id,
  };
};
interface DatePickerState {
  mounted: boolean;
  showDatePicker: boolean;
  startDate: any;
  endDate: any;
}

export const DatePicker: React.FC<any> = inject('context')(
  observer(({ context, ...props }: any) => {
    const { locale, site } = context;
    const siteId = site?.id?.toString();
    const [showDatePicker, setShowDatePicker] = React.useState(false);
    const location = useLocation();

    let dateFormat = 'MM/dd/yyyy';
    if(checkValue(props.dateFormat)){
      if(props.dateFormat !== ''){
        dateFormat = props.dateFormat;
      }
    }

    useEffect(() => {
      const updateButtonAttributes = () => {               
        const buttons = document?.querySelectorAll('[data-stid="date-picker-paging"]');
        buttons?.forEach((button, index) => {
          if (index === 0) {
            // First button (Previous)            
            button.setAttribute("title", "Previous month");
            button.setAttribute("aria-label", "Previous month");
          } else {
            // Second button (Next)
            button.setAttribute("title", "Next month");
            button.setAttribute("aria-label", "Next month");
          }
        });
      };
    
      // Run when the calendar popup appears
      const observer = new MutationObserver(updateButtonAttributes);
      observer.observe(document?.body, { childList: true, subtree: true });
    
      return () => observer.disconnect();
    }, [showDatePicker]);

    const onOpenCB = (name, isMobile) => {
      setShowDatePicker(true);
    };

    const toggleDatePicker = (e?: any) => {
      setShowDatePicker(!showDatePicker);
    };

    const onDismissCB = (isMobile, noUpdate?) => {
      if (isMobile) {
        closeMobileDialog();
      }

      if (!noUpdate) {
        toggleDatePicker();
      }
    };

    const closeMobileDialog = (): void => {
      setShowDatePicker(false);
    };

    const onMountCB = (startRef, endRef?) => {
      // useful for focus management.
      // do something with the refs.
    };

    const dialogWithExtraClassWrapper = (children, dateType) => (
      <DialogRoute id="datepicker">
          <Layer
            id={`datepicker-meso-${dateType}`}
            // lambda because I need to pass the argument
            // tslint:disable-next-line: jsx-no-lambda
            onDismiss={() => {
              onDismissCB(true);
            }}
          >
            <div className={`${checkValue(props.dialogWrapperOptionalClassName) ? props.dialogWrapperOptionalClassName : ''}`}>
              {children}
            </div>
          </Layer>
      </DialogRoute>
    );

    const dialogWrapper = (children, dateType) => {
      return <DialogRoute id="datepicker">
      <Layer
        id={`datepicker-meso-${dateType}`}
        // lambda because I need to pass the argument
        // tslint:disable-next-line: jsx-no-lambda
        onDismiss={() => {
          onDismissCB(true);
        }}
      >
      {children}
      </Layer>
  </DialogRoute>
    };

    const onSubmitCB = (start, end, isMobile) => {
      if (props.singleMode) {
        props.updateDates(start, props.startDateState);
      } else {
        props.updateDates(start, end, props.startDateState, props.endDateState);
      }

      if (isMobile) {
        closeMobileDialog();
      }
      toggleDatePicker();
    };

    const { selectCopy } = props;
    const buttonText: string = selectCopy;
    const datePickerAnalytics = {};

    const routerLinkWrapper = (children) => {
      return (
        <RouterLink
          to={{
            pathname: location.pathname,
            search: mergeQueryString(location.search, {
              pwaDialog: 'datepicker',
            }),
          }}
        >
          {children}
        </RouterLink>
      );
    };

    const dateFieldProps = {
      endAnalytics: setupTracker(':ChangeDatesEnd', 'Open Date Picker'),
      endId: props.endDateState,
      endInvalid: props.endInvalid ? props.endInvalid : '',
      endLabel: props.endLabel ? props.endLabel : 'Return date:',
      endName: 'EGDSDateRangePicker-EndDate-date_form_field',
      endPlaceholder: props.endPlaceHolder ? props.endPlaceHolder : 'End Date',
      routerLinkWrapper,
      showDatePicker: showDatePicker,
      startAnalytics: setupTracker(':ChangeDatesStart', 'Open Date Picker'),
      startId: props.startDateState,
      startInvalid: props.startInvalid ? props.startInvalid : '',
      startLabel: props.startLabel ? props.startLabel : 'Departure date:',
      startName: 'EGDSDateRangePicker-StartDate-date_form_field',
      startPlaceholder: props.startPlaceHolder ? props.startPlaceHolder : 'Start Date',
      dateFieldWrapperClasses: 'template-dtp invalid',
      dateFormat: props.dateFormat ? props.dateFormat : 'MM/dd/yyyy'
    };

    const datePickerProps = {
      analytics: datePickerAnalytics,
      buttonText,
      dateFieldProps,
      daysBookableInAdvance: 500,
      dialogWrapper: checkValue(props.dialogWrapperOptionalClassName) ? dialogWithExtraClassWrapper : dialogWrapper,
      doubleMonths: props.doubleMonths,
      startDate: props.startDate,
      endDate: props.endDate,
      firstDayOfWeek: locale === 'fr_FR' || siteId === '20' ? DayName.MON : DayName.SUN,
      footerText: '',
      midnightBookingOffset: 4,
      onDismissCB: onDismissCB,
      onMountCB: onMountCB,
      onOpenCB: onOpenCB,
      onSubmitCB: onSubmitCB,
      singleMode: props.singleMode,
      useSingleTrigger: props.useSingleTrigger,
      singleDateSelect: props.singleDateSelect,
      dateFormat: dateFormat
    };

    return <UitkDatePicker {...datePickerProps} />;
  })
);
